export const WEB_SOCKET_SERVER_PORT = 3201;
export const WEB_SOCKET_SERVER_URL = `ws://localhost:${WEB_SOCKET_SERVER_PORT}`;

export enum AutoRefreshEvents {
  REFRESH = "refresh",
}
